"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Vip_exports = {};
__export(Vip_exports, {
  default: () => Vip_default
});
module.exports = __toCommonJS(Vip_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.4769 4.13575C12.3633 3.98711 12.187 3.8999 12 3.8999C11.813 3.8999 11.6366 3.98711 11.5231 4.13575L8.34244 8.30095L4.29871 5.97955C4.08762 5.85837 3.82422 5.87672 3.63198 6.02602C3.43973 6.17531 3.35674 6.42596 3.42188 6.66049L5.92188 15.6605C5.99402 15.9202 6.23047 16.0999 6.49999 16.0999H17.5C17.7695 16.0999 18.006 15.9202 18.0781 15.6605L20.5781 6.66049C20.6432 6.42596 20.5603 6.17531 20.368 6.02602C20.1758 5.87672 19.9124 5.85837 19.7013 5.97955L15.6575 8.30095L12.4769 4.13575Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.89999 18.3998C5.89999 18.0684 6.16862 17.7998 6.49999 17.7998H17.5C17.8314 17.7998 18.1 18.0684 18.1 18.3998C18.1 18.7312 17.8314 18.9998 17.5 18.9998H6.49999C6.16862 18.9998 5.89999 18.7312 5.89999 18.3998Z",
      fill: "currentColor"
    }
  )
);
const SvgVip = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Vip_default = SvgVip;
